import { render, staticRenderFns } from "./gpc-banner-text-card.vue?vue&type=template&id=6d08b4da&scoped=true"
import script from "./gpc-banner-text-card.vue?vue&type=script&lang=js"
export * from "./gpc-banner-text-card.vue?vue&type=script&lang=js"
import style0 from "./gpc-banner-text-card.vue?vue&type=style&index=0&id=6d08b4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08b4da",
  null
  
)

export default component.exports